<span class="object-name-component {{stylingClass}}" *ngIf="name">
  <span *ngIf="!translate" [innerHTML]="name"></span>
  <span *ngIf="translate" [translate]="name"></span>
</span>
